import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import 'animate.css';
import './App.scss';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import WxCommon from './components/Wx/Common';
import StatManager from './utils/stat';
import { isWeb, isSupportWebp } from './utils/util';
import asyncComponent from './components/AsyncComponent';
import moment from 'moment';
const Demo = asyncComponent(() => import('./pages/Demo'));
const Gallery = asyncComponent(() => import('./pages/Gallery'));
const Order = asyncComponent(() => import('./pages/Order/index'));
const Permission = asyncComponent(() => import('./pages/Permission/index'));
const Video = asyncComponent(() => import('./pages/Video/index'));
const Me = asyncComponent(() => import('./pages/Me/index'));
const Person = asyncComponent(() => import('./pages/Person/index'));
const Share = asyncComponent(() => import('./pages/Share/index'));
const VideoIFrame = asyncComponent(() => import('./pages/VideoIFrame/index'));
const Group = asyncComponent(() => import('./pages/Group/index'));
const Exhibitor = asyncComponent(() => import('./pages/exhibitor/index'));


@inject('rootStore')
@observer
class App extends Component {
  constructor(props: any) {
    super(props);

    this.state = {
      show: false
    };
  }

  // React 16起，任何未被错误边界捕获的错误将导致整个组件树被卸载，所以这里直接报错来防止这个情况
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error(error, errorInfo);
  }

  componentDidMount() {
    StatManager.start();
    window.__stat = StatManager;
    // 设置一下最后浏览的相册
    // @ts-ignore
    const { wxuserStore, imStore } = this.props.rootStore!;
    // @ts-ignore
    // 最新相册的事，放到相册页去处理了，不用每个界面都做一下 2023-03-06
    // wxuserStore.setRecentGallery(
    //   window.gallery.id,
    //   window.configDetail && window.configDetail.h5_share_image
    // );
    wxuserStore.session().then(() => {
      this.setState({
        show: true
      });

      // 改来看看，非微信登录状态下，直接不进入IM
      if (!wxuserStore.user.is_mock) {
        // 如果当前已经活动结束了，也不需要进入IM
        if (moment(window.gallery!.end_time).add(1, `d`).isAfter(moment())) {
          imStore
            .login()
            .then(() => {
              if (window.gallery!.avchatroom) {
                imStore.joinGroup(window.gallery!.avchatroom);
              } else {
                imStore.joinGroup();
              }
            })
            .catch(() => { });
        }
      }
    });

    this.checkRootClass();
    this.checkBrowserFeature();
    this.checkCustomizeClass();
  }

  checkBrowserFeature() {
    window.__isSupportWebp = isSupportWebp();
  }

  checkRootClass() {
    if (isWeb()) {
      let rootElement = window.document.getElementById('root');
      if (rootElement) {
        let className = rootElement.className;
        rootElement.className = className + " pc";
      }

      let rootPageElement = window.document.getElementById('root-page');
      if (rootPageElement) {
        let className = rootPageElement.className;
        rootPageElement.className = className + " pc";
      }
    }
  }

  checkCustomizeClass() {
    let body = window.document.body;
    if (body) {
      body.className = `${body.className} source_${window.gallery?.external_source_id || `standard`} channel_${window.configDetail?.channel_id || `standard`}`;
    }
  }

  render() {
    // @ts-ignore
    return this.state.show ? (
      <Router>
        <React.Fragment>
          <Switch>
            <Route path={'/page/person/:id/:personid/:openid'} component={Person} />
            <Route path={'/page/share/:openid/:imageids'} component={Share} />
            <Route path={'/page/group/:token'} component={Group} />
            <Route path={'/demo'} component={Demo} />
            <Route path={'/page/me'} component={Me} />
            <Route path={'/page/order/:id'} component={Order} />
            <Route path={'/gti/:id/watermark/:customwatermark'} component={Gallery} />
            <Route path={'/gti/:id/original/:val'} component={Gallery} />
            <Route path={'/gti/:id'} component={Gallery} />
            <Route path={'/g/:linkid/visit/:parentid'} component={Gallery} />
            <Route path={'/g/:linkid/video/:videoid'} component={Video} />
            <Route path={'/page/permission/:id/original/:val'} component={Permission} />
            <Route path={'/page/permission/:id'} component={Permission} />
            <Route path={'/g/:id/original/:val'} component={Gallery} />
            <Route path={'/g/:id/watermark/:customwatermark'} component={Gallery} />
            <Route path={'/g/:id'} component={Gallery} />
            <Route path={'/page/exhibitor/:id'} component={Exhibitor} />
            <Route path={'/page/exhibitor/:id/:parentid'} component={Exhibitor} />
            <Route path={'/page/exhibitor/:id/original/:val'} component={Exhibitor} />
            <Route path={'/page/exhibitor/:id/watermark/:customwatermark'} component={Exhibitor} />
            <Route path={'/page/video/iframe'} component={VideoIFrame} />
          </Switch>
          <WxCommon />
        </React.Fragment>
      </Router>
    ) : null;
  }
}

export default App;
